import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvCategoriesList.html?raw';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { StringHelpers } from "../../../more/Helpers";


class EvCategoriesList extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
	templateString: any = template;
    private inputEvCategory: MdsLax<InstanceType<typeof HintBox>>;

    sectionAddEntry: HTMLElement;


    private tableContainer: HTMLElement;
    private reloadContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvCategoryInBooking>>>;
    private evBooking: VAM2types.EvBooking_Base;

    private entitylist: Array<any>;

    private tableLayout: StaticTable.RowConfig = {
        attributes: ["code", "description"],
        colNamesInternal: ["code", "description"],
        colspans: [1, 1],
        headings: ["General_Label_Code", "General_Description"],
        widths: ["16ch", null],
        alignmentsHeading: [null, null],
        alignmentsRow: [null, null]
    };

    private _emitHandle: any = null;
    
    private _afterDeleteEntry(rowGrp: StaticTable.StaticTableRowGroup<VAM2types.EvCategoryInBooking>) {
    }

    private _checkEnableDelete(entity: VAM2types.EvCategoryInBooking): boolean {
        //if (entity.documents?.length > 0) return false;
        return true;
    }

    private _onChange_StoreData() {
        let diffData = this.store.getDiffData(true);
        let completeList = this.store.getCurrentCompleteList();

        if (!this.table) {
            this.setupTable();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData, completeList);

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", diffData), 100);
    }

    private _onChangeCategory(): void {
        let value = this.inputEvCategory.getValue() as VAM2types.EvCategory;

        this.addNewEntry(value);

        this.inputEvCategory.setValue(null, true);
    }

    private _sortingTimeout: any = null;
    private addNewEntry(value: VAM2types.EvCategory) {
        if (value != null) {
           
            let fakeEvCategoryInBooking: Partial<VAM2types.EvCategoryInBooking> = {
                ID: StringHelpers.randomID(16),
                categoryID: value.ID,
                code: value.code,
                description: value.description,
                coloration: value.coloration,
                gDisp_1: value.gDisp_1
            }
            
            if (this.store.isEntityExisting(fakeEvCategoryInBooking as any, "categoryID", true)) {
                this.showToast({
                    title: this.translate(`EvCategoriesList_Toast_ExistInList`),
                    message: `**${value.description}**  ${this.translate(`EvCategoriesList_Toast_ExistInList_details`)}`,
                    messageIcon: "fas fa-info-circle",
                    iconClass: "fas fa-info-circle"
                });
            }
            else {
                this.store.addEntry(fakeEvCategoryInBooking as any, "new");
            }

            /* also das muss weg. von außerhalb mit eigenem Timeout eine Sortinfunktion IN der Table aufrufen ist nicht gut
            entweder Table kümmer sich selber drum mit ihrer Sorting-Config oder wir kümmern uns von außerhalb um die Sortierung bevor die Table
            die Daten bekommt */
        //    if (this._sortingTimeout) {
        //        clearTimeout(this._sortingTimeout);
        //    }
        //    this._sortingTimeout = setTimeout(lang.hitch(this.table, this.table.runAdditionalSorting), 150);
        }
    }

    getData() {
        return this.store.getCurrentCompleteList();
    }
    getDiffData() {
        let diffData = this.store.getDiffData();
        return diffData;
    }
    private _onPrivilegeLoaded(role: string, hasPriv: boolean) {
        if (hasPriv) {
            switch (role) {
                case "EvCategory_Edit":

                    //this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClick_EditEvServiceBooking), lang.hitch(this, this._checkEnableEdit));
                    break;

                case "EvCategory_Delete":
                    this.table.addDefaultRowActionButton("delete", lang.hitch(this, this._afterDeleteEntry), lang.hitch(this, this._checkEnableDelete), true);

                    break;
            }
        }
    }

    private _onClick_Cell(cell: StaticTable.StaticTableCell<VAM2types.EvCategoryInBooking>) {
        this.table.expandRow(cell.tableRow.rowGroup.rowIndex, true);
    }

    private setupTable(): void {

        this.tableContainer.innerHTML = null;

        this.hideNode(this.reloadContainer, !this.evBooking?.ID);

        this.table = new StaticTable();
        this.table.setVerticalAlign("middle");

        this.hasUserRole("EvCategory_Edit", lang.hitch(this, this._onPrivilegeLoaded, "EvCategory_Edit"), this.evBooking);
        this.hasUserRole("EvCategory_Delete", lang.hitch(this, this._onPrivilegeLoaded, "EvCategory_Delete"), this.evBooking);

        //this.table.setRowClick(lang.hitch(this, this._onClickOpenEvServiceBooking));

        //this.table.setFormatter(lang.hitch(this, this.tableFormatter));

        this.table.addLineConfig(this.tableLayout);

        this.table.placeAt(this.tableContainer);

        this.table.setupFromStore(this.store);
        this.table.setCyAttribute("evCategoriesList");
    }  

    private _onClick_reloadData(evt) {
        this.loadList();
    }

    private loadList() {
        if (!this.evBooking) return;

        this.StandbyStart();

        let data = {
            "bookingID": this.evBooking?.ID
        };

        this.RequestManager.callfunction(
            "Webtool_API_EvBooking__GetEvCategoriesInBooking",
            data,
            lang.hitch(this, this._onLoadListResponse),
            lang.hitch(this, this._onLoadListError)
        );
    }

    private _onLoadListResponse(response: Array<VAM2types.EvCategoryInBooking>) {
        this.StandbyStop();

        this.store.setup(response);
        this._onChange_StoreData();
    }

    private _onLoadListError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error);
    }

     private _onClick_OpenEvServicesSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvCategory",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<VAM2types.EvCategory>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;
        if (mode == "selectEvCategory") {
            for (let item of items) {

                let entity: Partial<VAM2types.EvCategory> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }

                this.addNewEntry(entity as any);
            }
        }
    }

   

    setup(data: Array<VAM2types.EvCategoryInBooking>, evBooking: VAM2types.EvBooking_Base) {
        this.store.setup(data, "ID");
        this.evBooking = evBooking;
        this.entitylist = data;
        this.setupTable();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));


        this.inputEvCategory.setLabelAttribute("description", "$service_type");
        this.inputEvCategory.addInlineButton(lang.hitch(this, this._onClick_OpenEvServicesSED));

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvCategoriesList);